import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Testimonials.css';

// Importing assets
import quoteImg from "../../Assets/Testimonials/quotes.png"; 
import leftArrow from "../../Assets/Testimonials/left.png";
import rightArrow from "../../Assets/Testimonials/right.png";

import user1 from '../../Assets/Testimonials/img (1).jpg';
import user2 from '../../Assets/Testimonials/img (2).jpg';
import user3 from '../../Assets/Testimonials/img (3).jpg';

const reviews = [
  {
    id: 1,
    text: "Annai Insulation has consistently delivered high-quality insulation materials within the promised timeframe. Their team understands industrial requirements and ensures every supply meets performance expectations. A reliable partner for our thermal insulation needs.",
    author: "Project Manager",
    role: "HVAC Contractor",
    image: user1
  },
  {
    id: 2,
    text: "The technical expertise and attention to detail provided by Annai Insulation are unmatched. They provided exactly what our boiler project required, ensuring long-term thermal efficiency.",
    author: "Operations Head",
    role: "Manufacturing Unit",
    image: user2
  },
  {
    id: 3,
    text: "Exceptional service and transparent dealings. We've worked with them on multiple projects across Chennai, and their timely completion and market-leading prices make them our first choice.",
    author: "Chief Engineer",
    role: "Infrastructure Firm",
    image: user3
  }
];

const Testimonials = () => {
  const [index, setIndex] = useState(0);

  const nextSlide = () => {
    setIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  return (
    <section className="client-section">
      <div className="client-container">
        <h2 className="client-title">Our Clientele Feedback</h2>

        <div className="testimonial-wrapper">
          <div className="quote-icon">
            <img src={quoteImg} alt="quote" className="quote-img-file" />
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.4 }}
              className="testimonial-content"
            >
              <p className="feedback-text">"{reviews[index].text}"</p>

              <div className="client-meta">
                <button className="nav-arrow" onClick={prevSlide} aria-label="Previous">
                  <img src={leftArrow} alt="previous" className="arrow-img" />
                </button>
                
                <div className="client-info">
                  <img src={reviews[index].image} alt={reviews[index].author} className="client-avatar" />
                  <h4>{reviews[index].author}</h4>
                  <p>{reviews[index].role}</p>
                </div>

                <button className="nav-arrow" onClick={nextSlide} aria-label="Next">
                  <img src={rightArrow} alt="next" className="arrow-img" />
                </button>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;